export const APP_RELEASE = {
  name: 'University Digital Library',
  version: '1.0.0',
  versionCode: 1,
  releasedAt: '2026-11-02',
  sha256: '5cfa9fe0847233bdaab3a584116f932eba2e20f301a62a4a99cec005cb44f3a4',
  size: '67 MB',
  fileName: 'university-digital-library-1.0.0.apk',
  href: '/assets/app/university-digital-library-1.0.0.apk',
  checksumHref: '/assets/app/SHA256SUMS',
  packageId: 'dz.opu.udl',
};
